import './Boletim.css'
const Boletim = (props) => {
    return (
        <div className='boletim'>
            <div className='titulo'><h5>{props.titulo}</h5></div>
            <div className='container flex'>
                <div className='item'><img className='img_boletim' src={props.img}></img></div>
                <div className='item texto'>
                    <div>{props.subtitulo}</div>
                    <div><a href={props.link1}>> Ver boletim completo</a></div>
                    <div><a href={props.link2}>> Ver versão para email</a></div>
                </div>
            </div>
        </div>
    )
}

export default Boletim